module.exports = __webpack_public_path__ + "img/banner-data.ea9fa4dc.png";